export const replaceBackslashN = (input: string): string =>
  input.replace(/\\n/g, " ");
